/**
 * 点石引擎品牌 Logo（文件在 public/）
 * 必须使用 BASE_URL，与 vue.config.js 的 publicPath（如 /ai-agent/）一致，否则部署子路径下图片 404
 */
export const BRAND_LOGO_SRC = `${process.env.BASE_URL}logo-dianshi-engine.png`
/** 夜间模式反白 Logo */
export const BRAND_LOGO_WHITE_SRC = `${process.env.BASE_URL}logo-(bai).png`

export function getBrandLogoSrc(isDark) {
  return isDark ? BRAND_LOGO_WHITE_SRC : BRAND_LOGO_SRC
}
